import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export type CardPadding = 'none' | 'sm' | 'md';

const PADDING: Record<CardPadding, string> = { none: '', sm: 'p-3', md: 'p-4' };

/**
 * Class names for a white work surface on the page: a list row, a ticket, a panel. For anything that must
 * stay a `<li>`, `<article>` or `<button>`; `Card` below is the plain `<div>`.
 */
export function cardClasses(options: { padding?: CardPadding } = {}): string {
  const { padding = 'md' } = options;
  return cn('rounded-surface border border-line bg-white shadow-card', PADDING[padding]);
}

export function Card({
  padding,
  className,
  ...rest
}: HTMLAttributes<HTMLDivElement> & { padding?: CardPadding }) {
  return <div className={cn(cardClasses({ padding }), className)} {...rest} />;
}
